document.addEventListener('DOMContentLoaded', function() {
    const mobileToggle = document.querySelector('.cs-header__mobile-toggle');
    const closeBtn = document.querySelector('.cs-header__close-btn');
    const navigation = document.querySelector('.cs-header-navigation');
    const overlay = document.querySelector('.cs-header__overlay');
    const dropdownLinks = document.querySelectorAll('.cs-header-navigation__link');

    // Toggle mobile menu
    function toggleMenu() {
        navigation.classList.toggle('is-active');
        overlay.classList.toggle('is-active');
        document.body.classList.toggle('no-scroll');
    }

    mobileToggle.addEventListener('click', toggleMenu);
    closeBtn.addEventListener('click', toggleMenu);
    overlay.addEventListener('click', toggleMenu);

    // Handle dropdowns on mobile
    dropdownLinks.forEach(link => {
        if (link.nextElementSibling) {
            link.addEventListener('click', function(e) {
                if (window.innerWidth <= 1024) {
                    e.preventDefault();
                    const dropdown = this.nextElementSibling;
                    const isActive = dropdown.classList.contains('is-active');
                    
                    // Close all other dropdowns
                    dropdownLinks.forEach(otherLink => {
                        if (otherLink !== link && otherLink.nextElementSibling) {
                            otherLink.nextElementSibling.classList.remove('is-active');
                        }
                    });

                    // Toggle current dropdown
                    dropdown.classList.toggle('is-active');
                }
            });
        }
    });

    // Close mobile menu when clicking outside
    document.addEventListener('click', function(e) {
        if (window.innerWidth <= 1024) {
            if (!navigation.contains(e.target) && !mobileToggle.contains(e.target)) {
                navigation.classList.remove('is-active');
                mobileToggle.classList.remove('is-active');
            }
        }
    });

    // Handle window resize
    window.addEventListener('resize', function() {
        if (window.innerWidth > 1024) {
            navigation.classList.remove('is-active');
            mobileToggle.classList.remove('is-active');
            document.querySelectorAll('.cs-mega-menu, .cs-header-navigation__sublist').forEach(dropdown => {
                dropdown.classList.remove('is-active');
            });
        }
    });

    // Sticky Header Implementation
    // Sticky Header Implementation
	const header = document.querySelector('[data-header]');
	let lastScroll = 0;
	let headerHeight = header.offsetHeight;
	let isSticky = false;
	
	// Set initial CSS variable for header height
	document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

	function handleScroll() {
		const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
		
		if (currentScroll > headerHeight) {
			if (currentScroll > lastScroll && isSticky) {
				// Scrolling down - hide header
				header.classList.remove('cs-header--sticky');
				document.body.classList.remove('has-sticky-header');
				isSticky = false;
			} else if (currentScroll < lastScroll && !isSticky) {
				// Scrolling up - show header
				header.classList.add('cs-header--sticky');
				document.body.classList.add('has-sticky-header');
				isSticky = true;
			}
		} else {
			// At the top - remove sticky
			header.classList.remove('cs-header--sticky');
			document.body.classList.remove('has-sticky-header');
			isSticky = false;
		}
		
		lastScroll = currentScroll;
	}

	// Throttle scroll event for better performance
	let ticking = false;
	window.addEventListener('scroll', function() {
		if (!ticking) {
			window.requestAnimationFrame(function() {
				handleScroll();
				ticking = false;
			});
			ticking = true;
		}
	});

	// Update header height on resize
	window.addEventListener('resize', function() {
		headerHeight = header.offsetHeight;
		document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
	});

	// Initial setup
	handleScroll();
});
